module.exports = __webpack_public_path__ + "img/RECYCLE_BIN.a1cb6001.svg";